import React from 'react';
import { Pane } from '@leverege/ui-elements';
import AttributeColumnRenderer from "./AttributeColumnRenderer.js";
import Util from "./Util.js";
import { ValueText } from "./ColumnText.js";
import Formatters from '../../attribute/formatter/Formatters.js';
import I18nResolvers from '../../attribute/i18nResolver/I18nResolvers.js';
import IntersectionObserverWrapper from "../../IntersectionObserverWrapper.js";
import { jsx as _jsx } from "react/jsx-runtime";
const USAGE = 'table';
export default class ArrayPrimitiveAttributeColumnRenderer extends AttributeColumnRenderer {
  renderCell = (data, props, context) => {
    const {
      cell: valueOpts
    } = this.column;
    const {
      value
    } = data;
    const original = data?.row?.original || data?.original;
    const vs = Util.getStyle(valueOpts, original /* , cxt */);
    const variantCxt = {
      context,
      value,
      columnModel: this.column,
      usage: USAGE
    };
    const variant = Util.getVariant(valueOpts, original, variantCxt);
    const paneVariant = Util.getVariant(valueOpts, original, variantCxt, 'paneVariant');
    const morePopupVariant = Util.getVariant(valueOpts, original, variantCxt, 'morePopupVariant');
    const moreToggleVariant = Util.getVariant(valueOpts, original, variantCxt, 'moreToggleVariant');
    const layout = Util.getLayout(valueOpts, original, variantCxt);
    if (value?.length === 1) {
      return /*#__PURE__*/_jsx(Pane, {
        variant: paneVariant,
        layout: layout,
        children: super.renderCell(data, props, context)
      });
    }
    const resolvedValue = this.formatAndI18nResolveValue(value);
    return /*#__PURE__*/_jsx(IntersectionObserverWrapper, {
      popupVariant: morePopupVariant,
      toggleVariant: moreToggleVariant,
      layout: layout,
      variant: paneVariant,
      value: value,
      children: resolvedValue?.map((item, index) => {
        return /*#__PURE__*/_jsx(ValueText, {
          "data-targetid": `${item}-${index}`,
          variant: variant,
          style: vs,
          children: item
        }, item);
      })
    });
  };
  formatAndI18nResolveValue = value => {
    if (value == null) {
      return this.column?.cell?.emptyValue;
    }
    const formattedValue = Formatters.format(value, this.column.formatter);
    return I18nResolvers.resolve(formattedValue, this.column);
  };
}